
export default class EstadosUF {
  constructor() {
    this.brasil = [
      { id: 1, value: "AC", text: "AC" },
      { id: 2, value: "AL", text: "AL" },
      { id: 3, value: "AM", text: "AM" },
      { id: 4, value: "BA", text: "BA" },
      { id: 5, value: "CE", text: "CE" },
      { id: 6, value: "DF", text: "DF" },
      { id: 7, value: "ES", text: "ES" },
      { id: 8, value: "GO", text: "GO" },
      { id: 9, value: "MA", text: "MA" },
      { id: 10, value: "MT", text: "MT" },
      { id: 11, value: "MS", text: "MS" },
      { id: 12, value: "MG", text: "MG" },
      { id: 13, value: "PA", text: "PA" },
      { id: 14, value: "PB", text: "PB" },
      { id: 15, value: "PR", text: "PR" },
      { id: 16, value: "PI", text: "PI" },
      { id: 17, value: "RJ", text: "RJ" },
      { id: 18, value: "RN", text: "RN" },
      { id: 19, value: "RS", text: "RS" },
      { id: 20, value: "RO", text: "RO" },
      { id: 21, value: "RR", text: "RR" },
      { id: 22, value: "SC", text: "SC" },
      { id: 23, value: "SP", text: "SP" },
      { id: 24, value: "SE", text: "SE" },
      { id: 25, value: "TO", text: "TO" },
    ];
  }
}
